import script from "./ProfileAvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAvisorComponent.vue?vue&type=style&index=0&id=b927a760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b927a760"]])

export default __exports__